import React from 'react'
import Routing from './Routing/Routing'
import { ChakraProvider } from '@chakra-ui/react'
import Theme from './theme'

function App() {
  return (
    <ChakraProvider theme={Theme}>
        <Routing/>
    </ChakraProvider>
  )
}

export default App
